function initHeaderTheme() {
  const header = document.querySelector(".site-header");

  if (!header) {
    return;
  }

  const sections = [
    ...document.querySelectorAll(".page-section--dark, .page-section--light"),
  ];

  if (!sections.length) {
    return;
  }

  const getTheme = (section) =>
    section.classList.contains("page-section--light") ? "light" : "dark";

  // Section-based light/dark only on desktop; mobile/tablet drawer has a dark bg.
  const desktopQuery = window.matchMedia("(min-width: 1261px)");

  const setTheme = (theme) => {
    header.classList.toggle("site-header--light", theme === "light");
    header.classList.toggle("site-header--dark", theme === "dark");
  };

  const updateHeaderTheme = () => {
    if (!desktopQuery.matches) {
      setTheme("dark");
      return;
    }

    const line = header.getBoundingClientRect().bottom;
    let theme = "dark";

    sections.forEach((section) => {
      if (section.getBoundingClientRect().top <= line) {
        theme = getTheme(section);
      }
    });

    setTheme(theme);
  };

  updateHeaderTheme();
  window.addEventListener("scroll", updateHeaderTheme, { passive: true });
  window.addEventListener("resize", updateHeaderTheme);
  desktopQuery.addEventListener("change", updateHeaderTheme);
}

initHeaderTheme();

function initMobileMenu() {
  const header = document.querySelector(".site-header");
  const toggle = document.getElementById("primary-menu-toggle");
  const menu = document.getElementById("primary-menu");

  if (!header || !toggle) {
    return;
  }

  const labelOpen = toggle.dataset.labelOpen || "";
  const labelClose = toggle.dataset.labelClose || "";
  const desktopQuery = window.matchMedia("(min-width: 1261px)");
  const mobileQuery = window.matchMedia("(max-width: 768px)");
  const LOGO_SCROLL_THRESHOLD = 24;

  const updateLogoVisibility = () => {
    if (!mobileQuery.matches) {
      header.classList.remove("is-logo-hidden");
      return;
    }

    if (header.classList.contains("is-menu-open")) {
      header.classList.remove("is-logo-hidden");
      return;
    }

    header.classList.toggle(
      "is-logo-hidden",
      window.scrollY > LOGO_SCROLL_THRESHOLD,
    );
  };

  const setOpen = (open) => {
    header.classList.toggle("is-menu-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    toggle.setAttribute("aria-label", open ? labelClose : labelOpen);
    document.body.classList.toggle("is-menu-open", open);
    updateLogoVisibility();
  };

  toggle.addEventListener("click", () => {
    setOpen(!header.classList.contains("is-menu-open"));
  });

  menu?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setOpen(false));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      setOpen(false);
    }
  });

  desktopQuery.addEventListener("change", (event) => {
    if (event.matches) {
      setOpen(false);
    }
  });

  mobileQuery.addEventListener("change", updateLogoVisibility);
  window.addEventListener("scroll", updateLogoVisibility, { passive: true });
  updateLogoVisibility();
}

initMobileMenu();
